export const PASSWORD_MIN_LENGTH = 12;

export interface PasswordRule {
  code: string;
  label: string;
  test: (password: string) => boolean;
}

export const PASSWORD_RULES: PasswordRule[] = [
  {
    code: "length",
    label: `至少 ${PASSWORD_MIN_LENGTH} 个字符`,
    test: (password) => password.length >= PASSWORD_MIN_LENGTH,
  },
  {
    code: "uppercase",
    label: "至少包含 1 个大写字母",
    test: (password) => /[A-Z]/.test(password),
  },
  {
    code: "lowercase",
    label: "至少包含 1 个小写字母",
    test: (password) => /[a-z]/.test(password),
  },
  {
    code: "digit",
    label: "至少包含 1 个数字",
    test: (password) => /[0-9]/.test(password),
  },
  {
    code: "special",
    label: "至少包含 1 个特殊字符，例如 !@#$%",
    test: (password) => /[^A-Za-z0-9]/.test(password),
  },
];

export interface PasswordValidation {
  ok: boolean;
  unmet: string[];
}

export function validatePassword(password: string): PasswordValidation {
  const unmet = PASSWORD_RULES.filter((rule) => !rule.test(password)).map((rule) => rule.code);
  return { ok: unmet.length === 0, unmet };
}

export function passwordRuleLabel(code: string): string {
  return PASSWORD_RULES.find((rule) => rule.code === code)?.label ?? code;
}
